import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BookCall from "../components/BookCall"; 
import ScrollToTopButton from "../components/ScrollToTopButton";



export default function WhatWeDoPage() {
  // Smooth scroll to anchor on load
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300);
      }
    }
  }, []);

  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <div
        className="text-white text-center d-flex align-items-center justify-content-center"
        style={{
          height: "60vh",
          backgroundImage: "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/wwd.png')"
,
          backgroundSize: "cover",
          backgroundPosition: "center",
          animation: "fadeIn 2s ease-in-out",
        }}
      >
        <div>
          <h1 className="display-4 fw-bold mb-3">What We Do</h1>
          <p className="lead">Building next-gen digital experiences for businesses worldwide.</p>
        </div>
      </div>

      {/* Service Sections */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Our Areas of Expertise</h2>
        <div className="row g-5">
          <Section
            id="software-dev"
            title="Custom Software Development"
            content="We build tailored software for web, mobile, and enterprise platforms using the latest technology stack."
            //icon="💻"
          />
          <Section
            id="mobile-dev"
            title="Mobile App Development"
            content="Native and cross-platform mobile apps"
            //icon="📱"
          />
          <Section
            id="cybersecurity"
            title="Cybersecurity Solutions"
            content="Comprehensive security audits, penetration testing, and protection against data breaches and cyber threats."
            //icon="🔐"
          />
          <Section
            id="testing"
            title="Automation & Manual Testing"
            content="Thorough testing processes to ensure your products are bug-free and stable before launch."
            //icon="🧪"
          />
          <Section
            id="training"
            title="IT Training & Upskilling"
            content="Hands-on training programs to help professionals gain expertise in development, DevOps, and more."
            //icon="🎓"
          />
          <Section
            id="marketing"
            title="Digital Marketing"
            content="SEO, social media campaigns, paid ads, and content marketing strategies to grow your brand."
            //icon="📈"
          />
        </div>
      </div>
      <BookCall />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}

function Section({ id, title, content, icon }) {
  return (
    <div id={id} className="col-md-6">
      <div className="p-4 shadow-sm border rounded h-100" style={{ backgroundColor: "#f9f9f9" }}>
        <h4 className="text-primary fw-bold mb-2">
          <span style={{ fontSize: "1.5rem", marginRight: "10px" }}>{icon}</span>
          {title}
        </h4>
        <p className="text-muted mb-0">{content}</p>
      </div>
    </div>
  );
}
